import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SettingsSubSideNavSectionHeaderProps = ComponentPropsWithoutRef<'h2'>;

export const SettingsSubSideNavSectionHeader = memo(
  ({ className, ...restOfProps }: SettingsSubSideNavSectionHeaderProps) => {
    return (
      <h2
        className={cn(
          'px-2 pt-3 pb-2 font-semibold ads:text-metadata text-10 text-gray-10 uppercase tracking-wider',
          className,
        )}
        {...restOfProps}
      />
    );
  },
);

SettingsSubSideNavSectionHeader.displayName = 'SettingsSubSideNavSectionHeader';
